<template>
    <Teleport v-if="isMobile && mobileTargetExists" to=".main-menu-nav-list">
        <QuickSearchBox v-click-outside="deactivate" is-mobile />
    </Teleport>

    <QuickSearchBox v-if="isDesktop" v-click-outside="deactivate" />
</template>

<script lang="ts" setup>
import { computed, ref, watch } from "vue";
import { useBreakpoints } from "@allwyn/utils/composables/use-breakpoints";
import { vClickOutside } from "@allwyn/utils/directives/v-click-outside";
import QuickSearchBox from "./components/quick-search-box.vue";
import { useQuickSearch } from "./composables/use-quick-search";
import { useHeader } from "../header/header.js";

const { isSearchResultPage, activate, deactivate } = useQuickSearch();

const isDesktop = useBreakpoints("sm2");
const isMobile = computed(() => !isDesktop.value);

const isPermanent = computed(() => isSearchResultPage || isMobile.value);

const mobileTargetExists = ref(false);

function checkMobileTarget() {
    mobileTargetExists.value = !!document.querySelector(".main-menu-nav-list");
}

function handleHeaderHidden() {
    deactivate();
}

const { isHeaderActive } = useHeader();

watch(isHeaderActive, (newActive) => {
    if (newActive === false) {
        handleHeaderHidden();
    }
});

watch(
    isPermanent,
    (newPermanent) => {
        if (newPermanent) {
            activate();
        } else {
            deactivate();
        }
    },
    { immediate: true }
);

watch(
    isMobile,
    () => {
        checkMobileTarget();
    },
    { immediate: true }
);
</script>
